import React, { useEffect, useState, useRef } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import { InfoBox, MainWrapper, PrimaryTab, PrimaryTabs, PrimaryTabsWrapper, StyledDivider } from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader } from "@egovernments/digit-ui-react-components";
import { useHistory } from "react-router-dom";
import { Box, Card } from "@mui/material";
import getResidentialData from "./getResidentialData";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../components/Button";
import SearchSummary from "./Step4";
import { citizenBaseUrl } from "../../components/data";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const ResidentialSelfPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(Digit.SessionStorage.get("SELF_CURRENT_TAB") || 0);
  const [createDataResponse, setCreateDataResponse] = useState({});
  const [, setIsPreviewLoading] = useState(false);
  console.log("creatDataResponse", createDataResponse);
  const { applicationData, isAppDataLoading } = getResidentialData(id);
  const { info: userInfo } = Digit.UserService.getUser();
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const Modal = useModal();
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const { data: { BPA: { Organizations: departmentList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", [
    "Organizations",
  ]);
  const { data: { BPA: { AVPSchemesUnitData: avpData } = {} } = {}, isLoading: isAvpDataLoading } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", [
    "AVPSchemesUnitData",
  ]);
  const avpUnits = avpData?.map((item) => {
    return { name: item.Unit, label: item.Unit, value: item.Unit };
  });
  // const { data: { BPA: { LandUseVillageMasterData: villagesData } = {} } = {}, isLoading: isVillagesLoading } = Digit.Hooks.obps.useMDMS(
  //   tenantId,
  //   "BPA",
  //   ["LandUseVillageMasterData"]
  // );
  const villagesData = [];
  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  console.log("logoData", { logoStore, avpLogo, daLogo });

  const daList = departmentList?.filter((item) => item.Type === "DA");
  const avpList = departmentList?.filter((item) => item.Type === "AVP")?.filter((item) => item.ShortName === "UPAVP");

  function filterDepartmentsList(completeList) {
    const officeNames = completeList?.map((office) => ({ value: office.Name, label: office.Name }));
    return officeNames;
  }
  const officesList = applicationFlow === "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_SELF_RESIDENTIAL", applicationData);

  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  const handleTabChange = (nextTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      data.planOn = "SELF_MAP";
      data.riskType = "LOW";
      data.businessService = applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      if (activeTab === 0 && !data?.applicationNo) {
        data.workflow = { action: "INITIATE", assignes: null };
        Digit.OBPSService.create({ BPA: data }, tenantId)
          .then((res) => {
            setCreateDataResponse(res?.BPA?.[0]);
            if (res?.BPA?.length > 0) {
              onSelect("", res.BPA[0], true);
              Modal("Application Created", `Application Created Successfully!`, "success");
              setActiveTab(nextTab);
              Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        data.workflow = { action: activeTab !== 3 ? "UPLOAD_DOC" : "MAKE_PAYMENT_SELF", assignes: null };
        Digit.OBPSService.update({ BPA: data }, tenantId)
          .then((res) => {
            setCreateDataResponse(res?.BPA?.[0]);
            if (res?.BPA?.length > 0) {
              onSelect("", res.BPA[0], true);
              Modal("Application Update", `Application Updated Successfully!`, "success");
              setActiveTab(nextTab);
              Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
              if (activeTab === 3) {
                history.push(
                  `${citizenBaseUrl}/payment/collect/${formData?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}/${params?.applicationNo}/${tenantId}/tenantId=${tenantId}`
                );
                // clearParams()
                // Digit.SessionStorage.del("SELF_CURRENT_TAB");
                // Digit.SessionStorage.del("FORM_SELF_RESIDENTIAL");
                setActiveTab(3);
                Digit.SessionStorage.set("SELF_CURRENT_TAB", 3);
              }
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      }
    } else {
      setActiveTab(nextTab);
      Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
    }
  };
  const handleLoadDocument = async (fileStoreId) => {
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const componentRef = useRef();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };

  if (isAppDataLoading && !applicationData) {
    return <Loader />;
  }
  if (id && isAppDataLoading && !applicationData?.landInfo?.owners?.[0]?.name) {
    return <Loader />;
  }
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }

  const renderContent = () => {
    if (activeTab === 0) {
      return (
        <Step1
          formData={params}
          userInfo={userInfo}
          handleTabChange={handleTabChange}
          id={id}
          officesList={officesList}
          villagesData={villagesData}
          departmentList={departmentList}
          isEmployee={false}
          applicationFlow={applicationFlow}
          avpUnits={avpUnits}
          avpData={avpData}
        />
      );
    } else if (activeTab === 1) {
      return <Step3 formData={params} userInfo={userInfo} handleTabChange={handleTabChange} id={id} />;
    } else if (activeTab === 2) {
      return (
        <React.Fragment>
          <Step2 formData={params} userInfo={userInfo} handleTabChange={handleTabChange} id={id} initFormMTDocs={initFormMTDocs} />
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <div>
              <span className="template-Text" style={{ fontSize: "1rem" }}>
                NOTE - DRAWING TEMPLATE:
              </span>
              <a className="pretty-link" style={{ marginLeft: "5px" }} onClick={() => handleLoadDocument("e30ebe3d-f548-405e-9ec3-130a2ffd3c37")}>
                DOWNLOAD
              </a>
            </div>
            <InfoBox>
              Attach all necessary documents demonstrating legal ownership <span>*</span>
            </InfoBox>
          </div>
        </React.Fragment>
      );
    } else if (activeTab === 3 && params?.applicationNo) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration={true}
              logoData={applicationFlow == "DA" ? daLogo : avpLogo}
            />
            {/* formData, ref, handleDeclarationChange, declarationChecked, showDeclaration = false */}
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={params?.status === "REVERT_TO_APPLICANT" ? "Forward to Department" : "Make Payment"}
                type="submit"
                sx={{ backgroundColor: "#157CB3", width: "180px" }}
                onClick={() => handleTabChange(4, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <MainWrapper>
        {/* <HeaderContent applicationFlow={applicationFlow} /> */}
        <BackButton />
        <Box sx={{ boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", overflowY: "auto", padding: "20px" }} className="bg-white">
          <FormStrip formName={"Self Certification via Registration"} />
          <PrimaryTabsWrapper>
            {/* Tabs Header */}
            <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
              <PrimaryTab label="Application Form" />
              <PrimaryTab label="Details of Map" />
              <PrimaryTab label="Documents" />
              <PrimaryTab label="Summary" />
            </PrimaryTabs>
          </PrimaryTabsWrapper>
          <StyledDivider />
          {renderContent()}
        </Box>
      </MainWrapper>
    </React.Fragment>
  );
};

export default ResidentialSelfPortal;
